<template>
  <div>
    <div class="case-item-wrapper d-flex case-item-wrapper gap-md gap-sm-lgp">
      <PreviewImageButton
        :src="styleColor.images.front.url"
        class="image-wrapper flex-shrink-0"
        @click="navigateToDetailPage"/>
      <div class="d-flex flex-column justify-content-between w-100">
        <div>
          <TextLineLimit class="mb-0">
            {{ styleColor.style.brand }} {{ styleColor.style.subcategory }}
          </TextLineLimit>
          <div class="d-flex justify-content-between">
            <p class="small-text mb-sm">
              Size {{ packageItem.item.trueSize }}
            </p>
            <p
              v-if="showBuyButton && styleColor.style.retailPrice"
              class="small-text mb-sm strike-through">
              Retail ${{ styleColor.style.retailPrice }}
            </p>
          </div>
        </div>
        <div class="d-flex flex-column gap-sm">
          <div
            v-if="isHeldForPurchase"
            class="text-success my-2">
            <strong>Held for purchase</strong>
          </div>
          <template v-else>
            <BaseButton
              v-if="showBuyButton && packageItem.item.priceClient"
              variant="tertiary"
              :text="`Buy Now - $${buyNowPrice}`"
              class="w-100 condensed"
              @click="openPurchaseItemFlyout(packageItem)"/>
            <BaseButton
              v-if="showReviewButton"
              :text="packageItem.reviewed ? 'Reviewed' : 'Review'"
              class="w-100 condensed"
              :disabled="packageItem.reviewed"
              @click="reviewItem(packageItem)">
              <template
                v-if="packageItem.reviewed"
                #icon>
                <SvgCheck/>
              </template>
            </BaseButton>
          </template>
          <slot name="buttons"/>
        </div>
      </div>
    </div>
    <p
      v-if="$slots.extraInfo"
      class="small-text mt-md">
      <slot name="extraInfo"/>
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import PreviewImageButton from '@shared/components/ADORN/PreviewImageButton.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import { useReviewStore } from '@/stores/review.js'
import { useOverlaysStore } from '@/stores/overlays.js'
import { useFlyouts } from '@/composables/flyouts.js'
import useScreenSize from '@shared/composables/screenSize.js'
import { slugify } from '@/utils/stringParsing.js'
import TextLineLimit from '@/components/global/sequin/TextLineLimit.vue'
import SvgCheck from '@/components/global/svg/SvgCheck.vue'
const props = defineProps({
  packageItem: {
    type: Object,
    required: true
  },
  showBuyButton: {
    type: Boolean,
    default: true
  },
  showReviewButton: {
    type: Boolean,
    default: true
  },
  showReturnButton: {
    type: Boolean,
    default: false
  },
  isReturning: {
    type: Boolean,
    default: false
  }
})

const store = useStore()
const styleColorsMap = computed(() => store.state.closet.styleColorsMap)
const styleColor = computed(() => styleColorsMap.value[props.packageItem.item.styleColor])
const itemsHeldForPurchase = computed(() => store.state.case.itemsHeldForPurchase)

const isHeldForPurchase = computed(() => {
  return itemsHeldForPurchase.value.filter(
    x => x.id === props.packageItem.id
  ).length > 0
})

const router = useRouter()
const buyNowPrice = computed(() => {
  return props.packageItem.item.returnBy ? props.packageItem.item.priceClient - 30 : props.packageItem.item.priceClient
})
const reviewStore = useReviewStore()
const { reviewItems } = storeToRefs(reviewStore)
const { navigateToReviewSingleItem } = reviewStore
const { closeFlyout } = useOverlaysStore()
const { isTabletOrSmaller } = useScreenSize()
const flyouts = useFlyouts()


function openPurchaseItemFlyout (item) {
  const flyoutName = props.isReturning ? 'purchase-returning-item' : 'purchase-item'
  store.dispatch('case/setMyCaseFlyoutContext', { itemToPurchase: item })
  store.dispatch('case/setMyCaseFlyoutName', flyoutName)
}

function reviewItem (item) {
  reviewItems.value = [item]
  closeFlyout()
  navigateToReviewSingleItem(item)
}

function navigateToDetailPage () {
  const slug = slugify(`${styleColor.value.style.brand} ${styleColor.value.style.name}`)
  if (isTabletOrSmaller.value) {
    router.push({ name: 'closet-detail', params: { id: styleColor.value.id , name: slug } })
  } else {
    flyouts.openClosetDetailFlyout(styleColor.value, null, null, true)
  }
}
</script>

<style lang="scss" scoped>
.image-wrapper {
  --small-width: calc(48vw - (24px + 16px));
  max-width: min(var(--small-width), 175px, 100%); 
  height: auto;
  width: 175px;
  @media (max-width: 365px) {
  --small-width: calc(35vw - (24px + 16px));
  }
}

</style>